<router-outlet></router-outlet>

<app-spinner *ngIf="spinner.spinning$ | async"></app-spinner>
